import React, { useMemo } from "react";
import { EChartsOption } from "echarts";
import ReactEchart from "../../../../../../molecules/ReactEchart";
import "../../index.css";

const SpeedGaugeChart = React.memo(({ renewalAcceptedPercentage }: any) => {
  const options = useMemo<EChartsOption>(
    () => ({
      series: [
        {
          type: "gauge",
          startAngle: 180,
          endAngle: 0,
          min: 0,
          max: 100,
          splitNumber: 12,
          itemStyle: {
            color: "#184461",
            shadowBlur: 0,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
          },

          pointer: {
            icon: "path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z",
            length: "75%",
            width: 16,
            offsetCenter: [0, "15%"],
          },
          axisLine: {
            roundCap: false,
            lineStyle: {
              width: 30,
              color: [[1, "#D9D9D9"]],
            },
          },
          progress: {
            show: true,
            roundCap: false,
            width: 30,
            itemStyle: {
              color: "#347094",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          title: {
            show: false,
          },
          detail: {
            backgroundColor: "transparent",
            borderColor: "transparent",
            borderWidth: 0,
            width: "60%",
            lineHeight: 40,
            height: 40,
            borderRadius: 8,
            offsetCenter: [0, "45%"],
            valueAnimation: true,
            formatter: function (value: number) {
              return `{value|${value.toFixed(0)}%}`;
            },
            rich: {
              value: {
                fontSize: 25,
                fontWeight: "bolder",
                color: "#347094",
              },
            },
          },
          data: [
            {
              value: renewalAcceptedPercentage,
            },
          ],
        },
      ],
    }),
    [renewalAcceptedPercentage]
  );

  return (
    <div className="speed-guage-chart">
      <ReactEchart options={options} style={{ width: "100%", height: "100%", textAlign: "center" }} />
    </div>
  );
});

export default SpeedGaugeChart;
